(function() {
  var SECTION_SELECTOR = '[data-mm-related-products-v2-section]';

  function initSlick(sectionEl) {
    if (!sectionEl || sectionEl.dataset.mmRpV2SliderReady === 'true') return;

    var slider = sectionEl.querySelector('[data-mm-related-products-v2-slider]');
    if (!slider) return;

    var slideCount = slider.querySelectorAll('.mm-related-products-v2__slide').length;
    if (slideCount <= 0) return;
    if (slideCount === 1) {
      sectionEl.dataset.mmRpV2SliderReady = 'true';
      disconnectObserver(sectionEl);
      return;
    }

    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick === 'undefined') {
      return;
    }

    if (window.jQuery(slider).hasClass('slick-initialized')) {
      sectionEl.dataset.mmRpV2SliderReady = 'true';
      disconnectObserver(sectionEl);
      return;
    }

    window.jQuery(slider).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        { breakpoint: 990, settings: { slidesToShow: 3 } },
        { breakpoint: 749, settings: { slidesToShow: 1.4 } }
      ]
    });

    sectionEl.dataset.mmRpV2SliderReady = 'true';
    disconnectObserver(sectionEl);
  }

  function disconnectObserver(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl.mmRpV2Observer) {
      sectionEl.mmRpV2Observer.disconnect();
      sectionEl.mmRpV2Observer = null;
    }
  }

  function observeRecommendations(sectionEl) {
    if (!sectionEl || sectionEl.mmRpV2Observer) return;
    var recommendationsEl = sectionEl.querySelector('product-recommendations');
    if (!recommendationsEl) return;

    var observer = new MutationObserver(function() {
      initSlick(sectionEl);
    });

    observer.observe(recommendationsEl, { childList: true, subtree: true });
    sectionEl.mmRpV2Observer = observer;
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    initSlick(sectionEl);
    observeRecommendations(sectionEl);
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function(event) {
    var sectionId = event && event.detail ? event.detail.sectionId : null;
    if (!sectionId) return;
    var sectionEl = document.querySelector('#shopify-section-' + sectionId + ' ' + SECTION_SELECTOR);
    if (sectionEl) {
      sectionEl.dataset.mmRpV2SliderReady = '';
      disconnectObserver(sectionEl);
      initSection(sectionEl);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var sectionId = event && event.detail ? event.detail.sectionId : null;
    if (!sectionId) return;
    var sectionEl = document.querySelector('#shopify-section-' + sectionId + ' ' + SECTION_SELECTOR);
    if (!sectionEl) return;

    var slider = sectionEl.querySelector('[data-mm-related-products-v2-slider]');
    if (slider && typeof window.jQuery !== 'undefined' && window.jQuery(slider).hasClass('slick-initialized')) {
      window.jQuery(slider).slick('unslick');
    }
    disconnectObserver(sectionEl);
  });
})();
